export default __webpack_public_path__ + "static/vipul-6ae638645f297668f3e0ce9eeb3235e4.jpg";